import { call, put, takeLatest } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { generalActions } from "../store/reducers/generalReducer";
import { routeDivisionAPI } from "../api/api";
import {
  ROUTE_DIVISION_START,
  ROUTE_DIVISION_BY_AREA_START,
  routeDivisionStartedAC,
  routeDivisionErrorAC,
  routeDivisionStartAC,
  routeDivisionByAreaStartAC,
} from "../store/actions/routeDivisionActions";

type StartAction = ReturnType<typeof routeDivisionStartAC>;
type StartByAreaAction = ReturnType<typeof routeDivisionByAreaStartAC>;

function* handleRouteDivision(action: StartAction): Generator<any, void, any> {
  try {
    const response = yield call(routeDivisionAPI.divideRoutes, action.payload);

    if (response.status === 202) {
      yield put(routeDivisionStartedAC());
      yield put(
        generalActions.successAC({
          message:
            response.data?.message ||
            "Route division started. You will be notified when complete.",
          type: "success",
        })
      );

      // Refresh the routes list so the saved-routes page shows up-to-date data
      // yield put(
      //   routesTriggerActions.getRoutesTriggerAC({
      //     address: true,
      //   })
      // );

      // If the 202 response body includes a warning, show an additional info toast
      if (response.data?.warning) {
        yield put(
          generalActions.successAC({
            message: response.data.warning,
            type: "info",
          })
        );
      }
    }
  } catch (error: any) {
    const status = error?.response?.status;
    const data = error?.response?.data;

    if (status === 422) {
      // Validation error -- extract message and keep modal open
      const message =
        data?.message ||
        (data?.errors
          ? Object.values(data.errors).flat().join(". ")
          : "Validation failed. Please check your input.");
      yield put(routeDivisionErrorAC(message));
    } else if (status === 409) {
      yield put(
        routeDivisionErrorAC(
          data?.message || "A route division batch is already in progress."
        )
      );
    } else {
      yield put(
        routeDivisionErrorAC(
          data?.message || "Failed to start route division. Please try again."
        )
      );
    }
  }
}

function* handleRouteDivisionByArea(action: StartByAreaAction): SagaIterator {
  try {
    const response: { status: number; data: any } = yield call(
      routeDivisionAPI.divideBySelection,
      action.payload
    );

    if (response.status === 202) {
      yield put(routeDivisionStartedAC());
      yield put(
        generalActions.successAC({
          message:
            response.data?.message ||
            "Route division started. You will be notified when complete.",
          type: "success",
        })
      );

      // yield put(
      //   routesTriggerActions.getRoutesTriggerAC({
      //     address: true,
      //   })
      // );

      if (response.data?.warning) {
        yield put(
          generalActions.successAC({
            message: response.data.warning,
            type: "info",
          })
        );
      }
    }
  } catch (error: any) {
    const status = error?.response?.status;
    const data = error?.response?.data;

    if (status === 422) {
      const message =
        data?.message ||
        (data?.errors
          ? Object.values(data.errors).flat().join(". ")
          : "Validation failed. Please check your input.");
      yield put(routeDivisionErrorAC(message));
    } else if (status === 409) {
      yield put(
        routeDivisionErrorAC(
          data?.message || "A route division batch is already in progress."
        )
      );
    } else {
      yield put(
        routeDivisionErrorAC(
          data?.message || "Failed to start route division. Please try again."
        )
      );
    }
  }
}

export function* routeDivisionWatcher() {
  yield takeLatest(ROUTE_DIVISION_START, handleRouteDivision);
  yield takeLatest(ROUTE_DIVISION_BY_AREA_START, handleRouteDivisionByArea);
}
